<div class="maap-service-select">
  <!-- <label for="serviceGroup">Service Group</label> -->
  <p-select 
    id="serviceGroup"
    [(ngModel)]="selectedGroup"
    (onChange)="changeServiceGroup($event.value)"
    [options]="serviceGrpOptions" 
    [filter]="true"
    [styleClass]="'w-100'">
    <ng-template let-item pTemplate="selectedItem">
      <span>{{item.label}}</span>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="ui-helper-clearfix service-group-option">
        <div class="service-group-option-label">
          {{item.label}}
        </div>
      </div>
    </ng-template>
  </p-select>
</div>
